//////////////////
// IMPORTS
//////////////////
// libraries
import { withRouter } from "found";
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// login-wrapper imports
import { LoginDefault } from "./login-default";
import { LoginInvite } from "./login-invite";
import { LoginWelcome } from "./login-welcome";
import { loginWrapperFragments, loginWrapperQuery } from "./LoginWrapper.gql";
import { IContainer, IProps } from "./LoginWrapperTypes";

// state
import { withRouteQuery } from "#webapp/src/routing/routes.util";
import { setLoginTrackingEvents } from "#webapp/src/util/loginTrackingEvents.util";
import { useIsOutlook } from "@clockwise/web-commons/src/util/OutlookContext";
import { useSelector } from "react-redux";
import { IReduxState } from "../../state/reducers/root.reducer";

//////////////////
// COMPONENT
//////////////////
const LoginWrapperCmpt = (props: IProps) => {
  const isWebExtension = useSelector((state: IReduxState) => state.webExtension.isWebExtension);

  const onSuccessTracking = () => {
    setLoginTrackingEvents();
  };

  const getRedirect = () => {
    if (props.match && props.match.params && props.match.params.redirect) {
      let redirect = props.match.params.redirect;
      if (window.location && window.location.search) {
        redirect += window.location.search;
      }
      return redirect;
    }
    return undefined;
  };

  const redirect = getRedirect();

  const isOutlook = useIsOutlook();
  if (isOutlook) {
    return (
      <LoginInvite
        isWebExtension={isWebExtension}
        isUserPresent={!!props.viewer.user}
        redirect={redirect}
        onSuccess={onSuccessTracking}
        isM365Only={true}
      />
    );
  }

  switch (props.variant) {
    case "invite":
      return (
        <LoginInvite
          isWebExtension={isWebExtension}
          isUserPresent={!!props.viewer.user}
          redirect={redirect}
          onSuccess={onSuccessTracking}
        />
      );
    case "welcome":
      return (
        <LoginWelcome viewer={props.viewer} redirect={redirect} onSuccess={onSuccessTracking} />
      );
    case "welcome-ambiguous":
      return (
        <LoginWelcome
          viewer={props.viewer}
          redirect={redirect}
          ambiguous={true}
          onSuccess={onSuccessTracking}
        />
      );
    case "m365":
      return (
        <LoginInvite
          isWebExtension={isWebExtension}
          isUserPresent={!!props.viewer.user}
          redirect={redirect}
          onSuccess={onSuccessTracking}
          isM365Only={true}
        />
      );
    case "default":
    default:
      return (
        <LoginDefault viewer={props.viewer} redirect={redirect} onSuccess={onSuccessTracking} />
      );
  }
};

const LoginWrapperWithRouter = withRouter(LoginWrapperCmpt);
//////////////////
// RELAY
//////////////////
export const LoginWrapper = createFragmentContainer<IContainer>(
  LoginWrapperWithRouter,
  loginWrapperFragments,
);

export const LoginWrapperPage = withRouteQuery(LoginWrapper, loginWrapperQuery);
